import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';

const DespesaFilterBar = ({ filters, onFiltersChange, onClearFilters, onApplyFilters }) => {
  const handleInputChange = (field, value) => {
    // Chama o handler do pai diretamente, atualizando o estado lá
    onFiltersChange({ ...filters, [field]: value });
  };

  const handleClear = () => {
    // Chama o handler de limpar do pai
        const clearedFilters = {
          dataBalanco: '', 
          conta: '', 
          descricao: '',
          numeroNF: '',
          valorMin: '',
          valorMax: ''
        };
        onClearFilters();
        // apply cleared filters immediately using explicit object to avoid stale state
        if (typeof onApplyFilters === 'function') onApplyFilters(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faSearch} className="mr-2 text-blue-500" />
          Filtros de Pesquisa
        </h3>
        <div className="flex items-center gap-2">
          <button
            onClick={() => { if (typeof onApplyFilters === 'function') onApplyFilters(filters); }}
            className="px-3 py-1 text-sm text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
          >
            Filtrar
          </button>
          {hasActiveFilters && (
            <button
              onClick={handleClear}
              className="flex items-center px-3 py-1 text-sm text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition-colors"
            >
              <FontAwesomeIcon icon={faTimes} className="mr-1" />
              Limpar Filtros
            </button>
          )}
        </div>
      </div>
      
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        <div>
          <label htmlFor="dataBalancoInicio" className="block text-sm font-medium text-gray-700 mb-1">
            Data Balanço (Início)
          </label>
          <input
            type="date"
            id="dataBalancoInicio"
            value={filters.dataBalancoInicio || ''}
            onChange={(e) => handleInputChange('dataBalancoInicio', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label htmlFor="dataBalancoFim" className="block text-sm font-medium text-gray-700 mb-1">
            Data Balanço (Fim)
          </label>
          <input
            type="date"
            id="dataBalancoFim"
            value={filters.dataBalancoFim || ''}
            onChange={(e) => handleInputChange('dataBalancoFim', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label htmlFor="conta" className="block text-sm font-medium text-gray-700 mb-1">
            Conta
          </label>
          <input
            type="text"
            id="conta"
            placeholder="Ex: Despesas Operacionais"
            value={filters.conta || ''}
            onChange={(e) => handleInputChange('conta', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label htmlFor="descricao" className="block text-sm font-medium text-gray-700 mb-1">
            Descrição
          </label>
          <input
            type="text"
            id="descricao"
            placeholder="Ex: Material de Escritório"
            value={filters.descricao || ''}
            onChange={(e) => handleInputChange('descricao', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label htmlFor="numeroNF" className="block text-sm font-medium text-gray-700 mb-1">
            Número NF
          </label>
          <input
            type="text"
            id="numeroNF"
            placeholder="Ex: NF-001"
            value={filters.numeroNF || ''}
            onChange={(e) => handleInputChange('numeroNF', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label htmlFor="valorMin" className="block text-sm font-medium text-gray-700 mb-1">
            Valor Mínimo
          </label>
          <input
            type="number"
            id="valorMin"
            placeholder="0,00"
            step="0.01"
            min="0"
            value={filters.valorMin || ''}
            onChange={(e) => handleInputChange('valorMin', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label htmlFor="valorMax" className="block text-sm font-medium text-gray-700 mb-1">
            Valor Máximo
          </label>
          <input
            type="number"
            id="valorMax"
            placeholder="999999,99"
            step="0.01"
            min="0"
            value={filters.valorMax || ''}
            onChange={(e) => handleInputChange('valorMax', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>

      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex flex-wrap gap-2">
            <span className="text-sm text-gray-600">Filtros ativos:</span>
            {(filters.dataBalancoInicio || filters.dataBalancoFim) && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                Data: {filters.dataBalancoInicio ? new Date(filters.dataBalancoInicio).toLocaleDateString('pt-BR') : '...'} - {filters.dataBalancoFim ? new Date(filters.dataBalancoFim).toLocaleDateString('pt-BR') : '...'}
                <button
                  onClick={() => { handleInputChange('dataBalancoInicio', ''); handleInputChange('dataBalancoFim', ''); }}
                  className="ml-1 text-blue-600 hover:text-blue-800"
                >
                  ×
                </button>
              </span>
            )}
            {filters.conta && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Conta: {filters.conta}
                <button
                  onClick={() => handleInputChange('conta', '')}
                  className="ml-1 text-green-600 hover:text-green-800"
                >
                  ×
                </button>
              </span>
            )}
            {filters.descricao && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                Descrição: {filters.descricao}
                <button
                  onClick={() => handleInputChange('descricao', '')}
                  className="ml-1 text-purple-600 hover:text-purple-800"
                >
                  ×
                </button>
              </span>
            )}
            {filters.numeroNF && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                NF: {filters.numeroNF}
                <button
                  onClick={() => handleInputChange('numeroNF', '')}
                  className="ml-1 text-indigo-600 hover:text-indigo-800"
                >
                  ×
                </button>
              </span>
            )}
            {filters.valorMin && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                Min: R$ {parseFloat(filters.valorMin).toFixed(2)}
                <button
                  onClick={() => handleInputChange('valorMin', '')}
                  className="ml-1 text-yellow-600 hover:text-yellow-800"
                >
                  ×
                </button>
              </span>
            )}
            {filters.valorMax && (
              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                Max: R$ {parseFloat(filters.valorMax).toFixed(2)}
                <button
                  onClick={() => handleInputChange('valorMax', '')}
                  className="ml-1 text-red-600 hover:text-red-800"
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DespesaFilterBar;
